<template>
  <div class="form-group">
    <label>
      <i class="title class-icon-title" :class="classIconTitle"></i>
      <span class="title" :style="'color: ' + titleColor">{{ title }} </span>
      <span class="required" v-if="required">*</span>
      <Tip :field="field" :formName="formName" />
    </label>
    <div class="inner-addon right-addon">
      <div class="required glyphicon" v-if="notifications.length > 0 && formDirty">
        <i class="fas fa-exclamation-triangle"></i>
      </div>
      <slot v-else></slot>
      <input type="text" :style="computedStyle" :placeholder="titlePlaceholder" :disabled="disabled"
        @keyup.enter.prevent="pressedEnter" @keyup="cleanedField" @blur="outField" v-mask="mask || withoutMask"
        v-bind:value="value" v-on:input="$emit('input', $event.target.value)" class="form-control"
        :class="{ required: notifications.length > 0 && formDirty }" />
    </div>
    <div v-if="formDirty">
      <div v-for="message in notifications" :key="message">
        <span class="invalid">{{ message }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Tip from "../shared/Tip.vue";
import { mapState, mapMutations } from "vuex";

export default {
  components: { Tip },
  name: "InputText",
  props: [
    "title",
    "classIconTitle",
    "field",
    "placeholder",
    "disabled",
    "titleColor",
    "mask",
    "_style",
    "formName",
    "required",
    "maxLength",
    "value",
    "enter",
    "cleaned",
    "exited",
    "markFormDirty",
    "borderRadius",
  ],
  data() {
    return {
      notifications: [],
      formDirty: false,
      withoutMask: {
        mask: "*".repeat(255),
        tokens: {
          "*": { pattern: /./ },
        },
      },
    };
  },
  created() {
    this.validate();
  },
  methods: {
    ...mapMutations("validation", [
      "addValidation",
      "removeValidation",
      "updateFormDirty",
    ]),
    validate() {
      this.notifications = [];

      if (this.required && this.value.length == 0) {
        var message = `${this.title} não pode ser vazio!`;
        this.notifications.push(message);
      }

      if (this.maxLength > 0) {
        if (this.value.length > this.maxLength) {
          var message = `Máximo de ${this.maxLength} caracteres!`;
          this.notifications.push(message);
        }
      }
    },
    pressedEnter() {
      if (this.enter) this.enter();
    },
    outField() {
      if (this.exited) this.exited();
    },
    cleanedField() {
      if (this.value.length == 0) {
        if (this.cleaned) this.cleaned();
      }
    },
  },
  computed: {
    ...mapState("validation", ["resetForm", "validations"]),
    titlePlaceholder() {
      if (!this.title) return this.placeholder;
      return "Digite o " + this.title;
    },
    computedStyle() {
      let style = this._style || "";
      if (this.borderRadius) {
        style += `border-radius: ${this.borderRadius}px !important;`;
      }
      return style;
    },
  },
  watch: {
    value() {
      this.validate();
      this.formDirty = true;
      // inverti a validação devido não colocar o default como true no props
      var _value = this.markFormDirty == undefined ? true : this.markFormDirty;
      if (_value) this.updateFormDirty(true);
    },
    notifications() {
      let self = this;
      this.notifications.forEach(function (notification) {
        let obj = {
          key: self.field + "&" + self.formName,
          formName: self.formName,
          notification: notification,
        };
        self.addValidation(obj);
      });

      if (this.notifications.length == 0) {
        let obj = {
          key: self.field + "&" + self.formName,
          formName: self.formName,
        };
        self.removeValidation(obj);
      }
    },
    resetForm: {
      handler(form) {
        if (form.name == this.formName) this.formDirty = false;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.title {
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #0a0a0a;
  letter-spacing: 0.5px !important;
}

input::placeholder {
  font-weight: 300 !important;
  opacity: 0.5;
  color: #969595;
}

.class-icon-title {
  margin-right: 5px;
}

.success {
  color: #94aa2a;
  font-size: 14px;
}

.invalid {
  color: #f0134d;
  font-size: 14px;
}

.margin-button {
  margin-top: -3px;
}
</style>
